const THUMBNAIL = {
  NONE  : 1,
  ICON  : 2,
  IMAGE : 3
};

const BANNER = {
  NONE  : 1,
  SOLID : 2,
  IMAGE : 3
};

const BANNER_TITLE = {
  UNDERLINED    : 1,
  LINE_LEFT     : 2,
  BETWEEN_LINES : 3
};

const TOP = {
  DEFAULT  : 1,
  WAVE     : 2,
  DIAGONAL : 3
};

const TITLE = {
  NONE          : 1,
  ICON_TOP      : 2,
  ICON_LEFT     : 3,
  UNDERLINED    : 4,
  BETWEEN_LINES : 5
};

const ALIGN = {
  LEFT   : 1,
  CENTER : 2,
  RIGHT  : 3
};

const TOPIC_THEME = {
  DEFAULT : 1,
  COMPACT : 2
};

const getTopicThemeById = id => {
  return {
    1 : 'default',
    2 : 'compact'
  }[id];
};

module.exports = {
  THUMBNAIL,
  BANNER,
  BANNER_TITLE,
  TOP,
  TITLE,
  ALIGN,
  TOPIC_THEME,
  getTopicThemeById
};
